function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M245.829 92.642c-2.59-2.167-5.503-4.767-13.489-6.826v-.109c11.439-29.472 3.561-41.174-7.446-50.384-7.986-6.718-21.907-8.018-32.806-5.526C180.325 7.91 153.562.217 128.202 0 102.843.217 76.08 7.91 64.209 29.689c-10.899-2.492-24.82-1.084-32.806 5.526-11.007 9.21-18.885 20.912-7.446 50.384v.108c-7.986 2.059-10.791 4.768-13.381 6.935C4.856 97.084 0 104.019 0 114.313c.54 16.361 13.489 140.425 13.489 140.425 0 .325.324.65.648.65.216 0 .324-.108.431-.216l11.655-10.944v17.662c0 .433.324.65.648.65.108 0 .324 0 .431-.217l19.749-17.12v10.294c0 .433.323.65.647.65.216 0 .324-.108.432-.217l11.115-10.727 7.662-7.368c.432 39.549-1.079 87.658-7.878 132.408-1.079 7.26 2.914 8.993 6.475 8.993 1.943 0 3.669-.541 4.532-.975 10.9-5.743 19.965-28.605 25.9-54.068 4.964-21.129 10.468-48.651 15.648-82.132 2.374 1.192 9.388 3.359 16.403 3.359 7.014 0 13.921-2.167 16.403-3.359 5.072 33.373 10.683 60.895 15.647 82.132 5.936 25.463 15 48.325 25.9 54.068.863.434 2.698.975 4.532.975 3.561 0 7.662-1.733 6.475-8.993-6.799-44.642-8.309-92.75-7.878-132.408l7.662 7.368 11.115 10.727c.108.109.324.217.432.217.324 0 .648-.325.648-.65v-10.294l19.748 17.12c.108.108.324.217.432.217.323 0 .647-.325.647-.65v-17.662l11.655 10.944c.108.108.323.216.431.216.324 0 .648-.216.648-.65 0 0 12.95-123.956 13.489-140.425.432-10.294-4.424-17.229-10.144-21.671",
  fill: "#564740"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M132.195 181.925l-3.993-3.792-3.992 3.792v.108l-4.641 4.66c2.698 2.817 5.612 4.334 8.633 4.334 3.022 0 5.936-1.517 8.634-4.334l-4.641-4.768",
  fill: "#483A34"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M140.936 194.927h-25.468l-1.079 8.452h27.627l-1.08-8.452",
  fill: "#AAD9BD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M110.828 195.469s-3.345 24.596-4.532 33.156c-9.713 66.421-23.418 136.2-39.173 143.027-1.187.541-2.266-.542-2.159-1.734 1.943-10.51 6.367-38.249 7.77-63.062 1.079-18.42 1.511-51.793 1.619-86.249l9.497-9.102c.755-.758 1.942-.433 1.942.759v8.56l25.036-25.355",
  fill: "#F7E3D6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M85.684 220.932v-8.56c0-1.192-1.187-1.517-1.942-.758l-5.936 5.634c-.107 2.926-1.402 55.26-1.402 66.096 0 30.122-7.77 77.364-7.015 77.364 6.799 0 16.295-102.394 19.425-143.135l-3.13 3.359",
  fill: "#FAF1EB"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M145.577 195.469s3.345 24.596 4.532 33.156c9.712 66.421 23.418 136.2 39.173 143.027 1.187.541 2.266-.542 2.158-1.734-1.942-10.51-6.367-38.249-7.769-63.062-1.08-18.42-1.511-51.793-1.619-86.249l-9.497-9.102c-.755-.758-1.942-.433-1.942.759v8.56l-25.036-25.355",
  fill: "#F7E3D6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M227.052 90.15c-5.504-.867-22.338-.65-22.554-.65l21.043-4.876c16.08-34.348-8.525-50.709-23.417-50.709-5.072 0-18.345 1.842-19.856 1.842 0 0 2.482-.326 3.129-.976 0-6.393-17.806-27.521-57.195-27.521-39.28 0-57.194 21.128-57.194 27.521.647.65 3.129.976 3.129.976-1.511 0-14.784-1.842-19.856-1.842-14.784 0-39.497 16.252-23.417 50.709L51.907 89.5c-.108 0-17.051-.109-22.554.65-7.554 1.192-22.339 9.318-22.339 23.729 0 6.718 2.806 26.547 2.806 26.547h236.657s2.806-19.829 2.806-26.547c.108-14.411-14.677-22.537-22.231-23.729",
  fill: "#63C199"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M217.664 47.025c-3.562-2.6-8.31-3.684-14.677-3.684 0 0-2.806.109-4.424.325-15.216 1.951-20.612 10.186-35.288 10.186-7.446 0-3.454-17.77-3.454-17.77s18.777.433 18.777-.867c0-5.743-22.122-22.321-48.885-22.321h-3.237c-26.763 0-48.886 16.578-48.886 22.321 0 1.3 18.778.867 18.778.867s4.1 17.77-3.454 17.77c-14.676 0-20.072-8.235-35.288-10.186-1.618-.216-4.424-.325-4.424-.325-6.367 0-11.115 1.084-14.677 3.684-4.964 3.684-15.108 17.445 2.59 40.091L51.691 89.5h152.591l10.576-2.384c17.914-22.754 7.77-36.515 2.806-40.091",
  fill: "#C5E4D0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M55.468 58.077c-1.079 0-2.05.325-2.914.975.324.326.432.651.432 1.084 0 .867-.647 1.517-1.511 1.517-.324 0-.647-.108-.971-.325-.54.975-.755 2.167-.755 3.359 0 3.684 2.59 6.609 5.827 6.609s5.827-2.925 5.827-6.609c-.107-3.684-2.697-6.61-5.935-6.61",
  fill: "#483A34"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M54.281 60.136c0-.758-.324-1.517-.863-1.95-.54-.542-1.187-.867-1.943-.867-1.511 0-2.806 1.3-2.806 2.817 0 .867.432 1.734 1.08 2.275.431.326 1.079.542 1.726.542 1.511 0 2.806-1.3 2.806-2.817",
  fill: "#FBF9F6"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M123.562 101.96l-6.691-6.284 6.799 6.393-.108-.109",
  fill: "#564740"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M77.914 217.14l-3.561 3.467 3.561-3.467M83.742 211.505l-5.828 5.635 5.828-5.635",
  fill: "#A8E1C2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M123.994 102.394l2.806 2.6-3.13-2.925.324.325",
  fill: "#564740"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M202.987 58.077a4.72 4.72 0 0 0-2.913.975c.323.326.431.651.431 1.084 0 .867-.647 1.517-1.511 1.517-.323 0-.647-.108-.971-.325-.539.975-.755 2.167-.755 3.359 0 3.684 2.59 6.609 5.827 6.609 3.238 0 5.828-2.925 5.828-6.609-.108-3.684-2.698-6.61-5.936-6.61",
  fill: "#483A34"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M201.8 60.136c0-.758-.324-1.517-.863-1.95-.54-.542-1.187-.867-1.943-.867-1.51 0-2.805 1.3-2.805 2.817 0 .867.431 1.734 1.079 2.275.431.326 1.079.542 1.726.542 1.511 0 2.806-1.3 2.806-2.817",
  fill: "#FBF9F6"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M132.843 101.96l6.69-6.284-6.798 6.393.108-.109",
  fill: "#564740"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M170.721 220.932v-8.56c0-1.192 1.187-1.517 1.942-.758l5.935 5.634c.108 2.926 1.403 55.26 1.403 66.096 0 30.122 7.77 77.364 7.015 77.364-6.799 0-16.295-102.394-19.425-143.135l3.13 3.359",
  fill: "#FAF1EB"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M178.491 217.14l3.561 3.467-3.561-3.467M172.663 211.505l5.828 5.635-5.828-5.635",
  fill: "#A8E1C2"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M132.411 102.394l-2.806 2.6 3.13-2.925-.324.325",
  fill: "#564740"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M207.951 110.195c-23.201-10.077-57.842-13.652-68.418-14.519l-6.798 6.393-.324.325-2.806 2.6c-.323.325-.863.542-1.403.542-.539 0-.971-.217-1.402-.542l-2.806-2.6-.324-.325-6.799-6.393c-10.575.867-45.216 4.442-68.417 14.519C23.525 121.03 9.82 141.293 9.82 140.426l1.187 12.894v-.109c37.447-43.016 113.095 28.606 113.095 28.606l3.992-3.793 3.993 3.793s75.649-71.622 113.095-28.606v.109l1.187-12.894c.216.867-13.489-19.396-38.418-30.231",
  fill: "#AAD9BD"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M124.21 181.925l-5.072-52.443c-5.396 7.043-15.108 13.327-31.08 13.327-24.82 0-39.496-32.614-76.943 10.402l7.662 83.541.54 4.009 10.575-10.836 1.295-72.921 1.619-1.084.54 91.45 12.518-10.835 5.719-4.984c.432-21.346 1.079-58.078 1.079-58.078l1.727-1.191.324 67.395 10.251-9.86.648-.65 6.151-5.959c.324-17.337.648-33.807.648-33.807l1.726-1.517.216 32.94 3.561-3.468 5.936-5.634c.323-.325.647-.433.971-.433.539 0 .971.433.971 1.192v8.559l38.418-39.115",
  fill: "#C5E4D0"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M157.016 82.348c-.324-.108-.648-.216-.972-.216H100.36c-.323 0-.755.108-.971.216-.755.434-1.187 1.301-.755 2.059l.324.434 24.604 23.187.108.109 3.13 2.925c.323.325.863.542 1.402.542.54 0 .972-.217 1.403-.542l3.13-2.925.108-.109 24.604-23.187c.108-.109.216-.217.324-.434a1.43 1.43 0 0 0-.755-2.059",
  fill: "#564740"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M132.195 181.925l5.072-52.443c5.396 7.043 15.108 13.327 31.08 13.327 24.82 0 39.496-32.614 76.943 10.402l-7.662 83.541-.54 4.009-10.575-10.836-1.295-72.921-1.619-1.084-.54 91.45-12.518-10.835-5.719-4.984c-.432-21.346-1.079-58.078-1.079-58.078l-1.727-1.191-.324 67.395-10.252-9.86-.647-.65-6.151-5.959c-.324-17.337-.648-33.807-.648-33.807l-1.726-1.517-.216 32.94-3.561-3.468-5.936-5.634c-.323-.325-.647-.433-.971-.433-.54 0-.971.433-.971 1.192v8.559l-38.418-39.115",
  fill: "#C5E4D0"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M232.34 68.479c0-2.167 0-4.226-.108-6.284v23.512c.108-17.661.108-16.794.108-17.228",
  fill: "#564740"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M92.375 60.569c12.302 0 4.964-20.262 4.964-20.262s.971 8.344-8.525 8.344c-18.346 0-18.346-6.393-33.022-6.393-12.087 0-15.971 3.901-15.971 3.901 27.841-6.718 34.748 14.41 52.554 14.41",
  fill: "#AAD9BD"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M141.908 202.62l-6.691-6.717c-2.374.325-4.64.433-7.015.433-2.374 0-4.748-.217-7.014-.433l-6.691 6.717-4.1 30.123c4.964 4.117 10.899 5.851 17.59 5.851h.431c6.799 0 12.626-1.734 17.59-5.851l-4.1-30.123",
  fill: "#C5E4D0"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M140.181 190.051l-3.345-3.467c-2.698 2.817-5.612 4.334-8.634 4.334-3.021 0-5.935-1.517-8.633-4.334l-3.345 3.467-.648 4.876c.756.217 1.403.326 2.159.434 3.453.65 6.906.975 10.467.975 3.562 0 7.123-.325 10.468-.975.756-.108 1.511-.325 2.158-.434l-.647-4.876",
  fill: "#63C199"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M164.03 60.569c-12.302 0-4.964-20.262-4.964-20.262s-.971 8.344 8.525 8.344c18.346 0 18.346-6.393 33.022-6.393 12.086 0 15.972 3.901 15.972 3.901-27.843-6.718-34.749 14.41-52.555 14.41",
  fill: "#AAD9BD"
});

function SvgSurge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1684,
    height: 2500,
    viewBox: "0 0 256 380",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurge);
export default __webpack_public_path__ + "static/media/surge.cff583e8.svg";
export { ForwardRef as ReactComponent };